import { t } from '../../i18next';

type ResultType = {
  isValid: boolean;
  errors: { [key: string]: { field: string; msg: string } };
};
export function UserIdValidator(rows, row) {
  const result: ResultType = {
    isValid: true,
    errors: {},
  };
  const filteredRow = rows.filter((item) => {
    return item.status !== 'N' && item.status !== 'E';
  });
  if (row.user_account_id !== null) {
    const newCheck = filteredRow.findIndex(
      (item) => item.user_account_id.toLowerCase() == row.user_account_id.toLowerCase() && item.user_account_id !== null,
    );
    if (newCheck >= 0) {
      result.isValid = false;
      result.errors.user_account_id = {
        field: 'user_account_id',
        msg: t('user_id_duplicate'),
      };
    }
    if (!row.email.includes('@')) {
      result.isValid = false;
      result.errors.email = { field: 'Email', msg: `Invalid Email` };
    }
  }
  return result;
}
